import { render, staticRenderFns } from "./GroupUserTable.vue?vue&type=template&id=9b94f6ce&scoped=true&"
import script from "./GroupUserTable.vue?vue&type=script&lang=js&"
export * from "./GroupUserTable.vue?vue&type=script&lang=js&"
import style0 from "./GroupUserTable.vue?vue&type=style&index=0&id=9b94f6ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b94f6ce",
  null
  
)

export default component.exports